import React from 'react';
import ActivityTable from './activityTable';
import useActivityState from '../hooks/useActivityState';

export default function UserActivityList () {
  const { data, total, loading, pagination, onPaginationChange } = useActivityState();

  return (
    <div className="user-activity-page">
      <h3>Activity Logs</h3>
      <ActivityTable
        data={data}
        loading={loading}
        total={total}
        pagination={pagination}
        onPaginationChange={onPaginationChange}
      />
    </div>
  );
};
